<script setup lang="ts">
import { storeToRefs } from 'pinia'

import Modal from '~/components/shared/modal.vue'
import { BtnOrange } from '~/components/ui/Buttons'

import { useUserInfluencerStore } from '~/stores/userInfluencer'

const localePath = useLocalePath()

const display = ref(false)

const { slug: SLUG } = storeToRefs(useUserInfluencerStore())

onMounted(() => {
  if (!window.localStorage.getItem('displayInfluencerValidationMessage')) return

  window.localStorage.removeItem('displayInfluencerValidationMessage')
  display.value = true
})

function go() {
  display.value = false

  return navigateTo(localePath(`/influencer/profile/${SLUG.value}/edit/`))
}
</script>

<template>
  <Modal
    v-model="display"
    :title="$t('layout.confirmations.influencerValidation00')"
  >
    <div class="tw-grid tw-grid-cols-1 tw-gap-10 tw-pb-6 tw-text-base">
      <div>
        <span>{{ $t('layout.confirmations.influencerValidation01') }}</span>
        <b>{{ $t('layout.confirmations.influencerValidation02') }}</b>
        <span>{{ $t('layout.confirmations.influencerValidation03') }}</span>
        <br />
        <br />
        <span>{{ $t('layout.confirmations.influencerValidation04') }}</span>
        <b>{{ $t('layout.confirmations.influencerValidation05') }}</b>
        <span>{{ $t('layout.confirmations.influencerValidation06') }}</span>
        <br />
        <br />
        <i>{{ $t('layout.confirmations.influencerValidation07') }}</i>
      </div>
      <BtnOrange @click="go">
        {{ $t('layout.confirmations.influencerValidation08') }}
      </BtnOrange>
    </div>
  </Modal>
</template>
